import {createSelector} from '@ngrx/store';
import {selectAdm1nState} from '@store/app.states';

export const selectAdminTangoState = createSelector(
  selectAdm1nState,
  (state) => state.tangoDash
);

export const selectSearchingState = createSelector(
  selectAdm1nState,
  (state) => state.tangoDash.uxInteractions.search
);
